import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.object.values";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";

var getSuggestedCurrentSlide = function getSuggestedCurrentSlide(container) {
  var wrapperOffset = container.getBoundingClientRect().left;
  var children = Array.from(container.children);
  var childrenDistance = children.reduce(function (a, x, i) {
    a[i] = Math.abs(wrapperOffset - x.getBoundingClientRect().left);
    return a;
  }, {});
  var closestChildDistance = Math.min.apply(Math, _toConsumableArray(Object.values(childrenDistance)));

  var _Object$keys$filter = Object.keys(childrenDistance).filter(function (k) {
    return childrenDistance[k] === closestChildDistance;
  }),
      suggestedCurrentSlide = _Object$keys$filter[0];

  var slideNumber = parseInt(suggestedCurrentSlide, 10);
  return slideNumber;
};

export { getSuggestedCurrentSlide as default };